var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aWalletSVG",
    d: "M29.102 13.106c.496 0 .898.405.898.904v6.994c0 .5-.402.905-.898.905h-1.139v4.101c0 1.097-.887 1.99-1.976 1.99H3.977A1.985 1.985 0 0 1 2 26.01V7.392C2 6.125 2.461 4 5.549 4H23.59c1.09 0 1.977.893 1.977 1.99v2.062h.419c1.09 0 1.976.893 1.976 1.99v3.064h1.139zM5.549 5.809c-1.338 0-1.692.485-1.744 1.33.142.412.466.913 1.519.913h18.447V5.99c0-.1-.08-.18-.18-.18H5.55zm20.617 20.2v-4.1h-4.97c-2.41 0-4.372-1.974-4.372-4.402 0-2.427 1.961-4.401 4.372-4.401h4.97v-3.064c0-.1-.08-.181-.18-.181H5.325c-.567 0-1.08-.1-1.527-.29V26.01c0 .1.08.18.18.18h22.01a.18.18 0 0 0 .18-.18zm2.037-5.91v-5.185h-7.007a2.587 2.587 0 0 0-2.575 2.593 2.587 2.587 0 0 0 2.575 2.593h7.007zM19.4 17.508c0-.93.752-1.688 1.677-1.688.924 0 1.677.757 1.677 1.688 0 .931-.753 1.69-1.677 1.69a1.685 1.685 0 0 1-1.677-1.69z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bWalletSVG",
    fill: "#fff",
    className: "fillColor"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aWalletSVG"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    className: "fillColor",
    fillRule: "nonzero",
    xlinkHref: "#aWalletSVG"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bWalletSVG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.be385fc0.svg";
export { ForwardRef as ReactComponent };